import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import idID from 'antd/locale/id_ID';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { useTranslation } from 'react-i18next';

import { App } from './App';
import './i18n';
import { lightTheme } from './theme';
import './styles.css';

/**
 * ⚠️ Locale AntD ikut bahasa aplikasi — kalau tidak, date picker & paginasi tetap berbahasa Inggris
 * di layar yang selebihnya Indonesia. Setengah-berpindah lebih membingungkan daripada tak berpindah.
 */
function Akar() {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider theme={lightTheme} locale={i18n.language === 'en' ? enUS : idID}>
      <App />
    </ConfigProvider>
  );
}

const root = document.getElementById('root');
if (root === null) throw new Error('#root tak ada di index.html');
createRoot(root).render(
  <StrictMode>
    <Akar />
  </StrictMode>,
);
